import EditTrapForm from './EditTrapForm'
import enhance from './EditTrapForm.enhancer.js'

export default enhance(EditTrapForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditTrapForm/index.js